(function($){
    // If the link is an anchor, JS will handle it for support of modern
    // Screen Readers and other Assistive Technologies
    $(document).on('click', 'a[href^="#"]:not(.skip-to-content-link)', function (e) {
        var href   = $(this).attr('href');
        var target = $(href);

        console.log('check!!');
        

        if (target.length === 0) {
            return;
        }

        e.preventDefault();

        if (target.attr('tabindex') === undefined) {
            target.attr('tabindex', '-1');
        }

        target.focus();
    });


    window.setTimeout( () => {
        if( $('.mapboxgl-ctrl-geocoder.mapboxgl-ctrl').length > 0 ){
            let $wrapper = $('.mapboxgl-ctrl-geocoder.mapboxgl-ctrl');
            let $input = $wrapper.find('.mapboxgl-ctrl-geocoder--input');
            let $parent = $wrapper.parents('.simple-search');

            if( $input.length > 0 && $parent.length > 0 ){
                $input.attr('id', 'locations-so-super-search-input');

                $parent.before('<p class="sr-only">This is a hot search: it doesn\'t need a submit button to complete the action. You will be prompted to enter the desired postcode or address, and the search will be showing results as you type.</p>');
                $parent.before('<label class="locations-so-super-search-input-label" for="locations-so-super-search-input">Postcode or address:</label>');
            }
        }

        if( $('.map.mapboxgl-map').length > 0 ){
            $('.map.mapboxgl-map').attr('aria-hidden', 'true');
        }
    }, 1000 );
})(jQuery);